module.exports = ".table-borderless > tbody > tr > td,\n.table-borderless > tbody > tr > th,\n.table-borderless > tfoot > tr > td,\n.table-borderless > tfoot > tr > th,\n.table-borderless > thead > tr > td,\n.table-borderless > thead > tr > th {\n  border: none; }\n\n.mailinglist {\n  padding-left: 0px;\n  max-height: 300px;\n  margin-bottom: 15px;\n  overflow-y: auto;\n  overflow-x: hide;\n  -webkit-overflow-scrolling: touch; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/modals/mailinglist/mailinglist-modal.component.scss
// module id = ./src/app/modules/modals/mailinglist/mailinglist-modal.component.scss
// module chunks = main